import * as React from "react";

export class TermsOfServicePage extends React.Component {
  componentWillMount(){
    window.location.href = "https://drive.google.com/a/seas.upenn.edu/file/d/1mgOn88ZCeDsSflycibQ32TGQZHI9r30E/view?usp=sharing";
  }
  render(){
    return (<section>Redirecting...</section>);
  }
}

export default TermsOfServicePage;


// WEBPACK FOOTER //
// ./src/pages/TermsOfService/TermsOfServicePage.tsx